import * as React from "react";
import {useNavigate} from "react-router-dom";

import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import {fetchPostForm, getDateObjectsFromUnix, getFilesSize} from "./memberFormSlice";
import Loader from "../ui/Loader";
import {updateFiles} from "./memberFilesSlice";

const MemberFormSubmit = (props: {uploadedFiles: FileList}) => {

  const {uploadedFiles} = props;
  // const dispatch = useAppDispatch();
  const memberFormState = useAppSelector((store) => store.memberFormState);
  const {calendarDates, marketingGoals, instagramPage, postFormStatus} = memberFormState;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSendMessageClick = async (event: React.FormEvent<EventTarget>) => {
    event.preventDefault();
    const dates = getDateObjectsFromUnix(calendarDates);
    const startPlan = dates[0].getFullYear() + "-" + dates[0].getMonth() + "-" + dates[0].getDate();
    const endPlan = dates[1].getFullYear() + "-" + dates[1].getMonth() + "-" + dates[1].getDate();

    let formData = new FormData();
    for (let x = 0; x < uploadedFiles.length; x++) {
      formData.append("media[]", uploadedFiles[x], uploadedFiles[x].name);
    }
    formData.append("instagramPage", instagramPage);
    formData.append("marketingGoals", marketingGoals);
    formData.append("startPlan", startPlan);
    formData.append("endPlan", endPlan);

    const submitData = {
      uploadedFiles,
      instagramPage,
      marketingGoals,
      startPlan,
      endPlan,
    }

    console.log("submit object and formData", submitData, formData);
    await dispatch(fetchPostForm({formData, navigate}));
    await dispatch(updateFiles({navigate}));
    const filesDiv = document.getElementById("section-files");
    if (filesDiv) {
      filesDiv.scrollIntoView({
        behavior: 'smooth'
      });
    }
    // dispatch(setUploadedFiles([...editedFiles, {fileName: "Dazzling_Diva.mp4"}]));
  }

  const filesSize = getFilesSize(uploadedFiles);

  return (
    <div className="ui-form__block flex flex--between">
      <span className="block max-240 small">By clicking on the «Send» button, you agree to the personal data processing policy.</span>
      <button className="ui-form__submit ui-button ui-button--violet max-240 width-100"
              disabled={filesSize > 25}
              onClick={handleSendMessageClick}>
        Send Message
        {postFormStatus === "loading" ? (
          <span className="ui-button__loader ui-button__loader--after">
            <Loader size={"button"}/>
          </span>
        ) : null}
      </button>
    </div>
  )
}

export default MemberFormSubmit
